import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

export function translateLoaderFactory(httpClient: HttpClient, platform: any) {
  return isPlatformBrowser(platform) ? multiTranslateLoader(httpClient) : null;
}

// MULTI TRANSLATE

export function multiTranslateLoader(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    {
      prefix: './assets/i18n/global/',
      suffix: `.global.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/i18n/dashboard/',
      suffix: `.dashboard.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/i18n/documentation/',
      suffix: `.documentation.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/i18n/ctl/',
      suffix: `.ctl.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/i18n/system-state/',
      suffix: `.system-state.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/i18n/admin-users/',
      suffix: `.admin-users.json?cacheBuster=${new Date().getTime()}`
    }
  ]);
}

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    public resources: { prefix: string; suffix: string }[] = [
      {
        prefix: '/assets/i18n/',
        suffix: `.json?cacheBuster=${new Date().getTime()}`
      }
    ]
  ) {}
  /**
   * Gets the translations from the server
   * @param lang
   * @returns {any}
   */
  public getTranslation(lang: string): any {
    return forkJoin(this.resources.map((config) => this.http.get(`${config.prefix}${lang}${config.suffix}`))).pipe(
      map((response) =>
        response.reduce((a: any, b: any) => {
          const obj: any = Object.assign(a, b);
          return obj;
        })
      )
    );
  }
}
